

module.exports = __webpack_require__.stylable.create(
    "MissedIcon2535678587",
    {"classes":{"root":"MissedIcon2535678587__root","rootCircle":"MissedIcon2535678587__rootCircle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "MissedIcon2535678587",
    null
);
